import { Component, Input, input } from '@angular/core';

import { BadgeComponent } from '../badge/badge.component';

@Component({
  selector: 'ui-card',
  imports: [BadgeComponent],
  templateUrl: './card.component.html',
})
export class CardComponent {
  readonly image = input<string>();
  @Input() badgeData: string;
  readonly title = input<string>();
  readonly description = input<string>();
  readonly altDescription = input<string>();
}
